const stringfyArrayItems = (items: string[]) => {
  return items && items.length
    ? items
        .reduce((prev: string[], item) => {
          return [...prev, item];
        }, [])
        .reduce((a, b, i, array) => a + (i < array.length - 1 ? ', ' : ' e ') + b)
    : '';
};

export default stringfyArrayItems;
